export default __webpack_public_path__ + "static/media/chat.b60f2bbc.png";